import React, { useState, useEffect } from 'react';
import { User, Briefcase, Award, Mail, Menu, X } from 'lucide-react';
// On supprime l'import de CustomLogo car on utilise maintenant l'image !
import './Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      
      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = (window.scrollY / windowHeight) * 100;
      setScrollProgress(scrolled);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <div className="scroll-progress-bar" style={{ width: `${scrollProgress}%` }}></div>
      
      <header className={`header ${scrolled ? 'scrolled' : ''}`}>
        <div className="header-content">
          
          {/* --- C'EST ICI QU'ON MET LE NOUVEAU LOGO --- */}
          <div className="logo" onClick={() => scrollToSection('hero')}>
            <img 
              src="/logoPortfolio.png" 
              alt="Logo Omar Aldroubi" 
              className="nav-custom-logo" 
            />
            <span className="logo-text">OMAR ALDROUBI</span>
          </div>

          <button className="mobile-menu-btn" onClick={toggleMobileMenu} aria-label="Menu">
            {isMobileMenuOpen ? <X size={28} color="#d4af37" /> : <Menu size={28} color="#d4af37" />}
          </button>

          <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
            <button onClick={() => scrollToSection('about')} className="nav-link">
              <User size={18} />
              <span>À Propos</span>
            </button>
            <button onClick={() => scrollToSection('filmography')} className="nav-link">
              <Briefcase size={18} />
              <span>Projets</span>
            </button>
            <button onClick={() => scrollToSection('skills')} className="nav-link">
              <Award size={18} />
              <span>Compétences</span>
            </button>
            <button onClick={() => scrollToSection('contact')} className="nav-link">
              <Mail size={18} />
              <span>Contact</span>
            </button>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;